export default "<app-page></app-page>\n<app-loading [loading]=\"loading\"></app-loading>\n"